import { TabModificationPeriodeComponent } from './../../tabs/tabModificationPeriode/tabModificationPeriode.component';
import { Periode } from './../../../../models/periode.model';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Recette } from '../../../../models/recette.model';
import { NbDialogRef } from '@nebular/theme';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';


@Component({
  selector: 'app-modificationRecette',
  templateUrl: './modificationRecette.component.html',
  styleUrls: ['./modificationRecette.component.scss']
})
export class ModificationRecetteComponent implements OnInit {
  @Input() recette: Recette;
  @Input() periodes: Periode[];
  receivedPeriodes: Periode[];
  constructor(protected ref: NbDialogRef<ModificationRecetteComponent>) { }

  ngOnInit() {
  }

  dismiss() {
    this.ref.close();
  }

}
